module.exports = __webpack_public_path__ + "media/images/icon-experience-fe1f8b00cd339e02eec36928631a2bc2.svg";